import type {BioIconProps} from '../../icons/common-types'
import {FlagIconsUS} from '../../icons/flag-icons-us'

export default function BestPatrioticPicksLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M23.9335 10.28L23.7468 10.1733L21.8935 9.10663L18.0668 6.8933C16.8935 6.2133 15.1068 6.2133 13.9335 6.8933L10.1068 9.10663L8.25346 10.1866L8.01346 10.32C5.6268 11.92 5.4668 12.2133 5.4668 14.7866V20.9333C5.4668 23.5066 5.6268 23.8 8.0668 25.44L13.9335 28.8266C14.5201 29.1733 15.2535 29.3333 16.0001 29.3333C16.7335 29.3333 17.4801 29.1733 18.0668 28.8266L23.9868 25.4C26.3735 23.8 26.5335 23.5066 26.5335 20.9333V14.7866C26.5335 12.2133 26.3735 11.92 23.9335 10.28Z"
          fill="white"
        />
        <path
          d="M8.25293 10.1865L10.1063 9.1065L13.7596 6.99984L13.9329 6.89317C15.1063 6.21317 16.8929 6.21317 18.0663 6.89317L18.2396 6.99984L21.8929 9.1065L23.7463 10.1732V7.31984C23.7463 4.31984 22.0929 2.6665 19.0929 2.6665H12.8929C9.89293 2.6665 8.25293 4.31984 8.25293 7.31984V10.1865Z"
          fill="white"
        />
        <path
          d="M19.7867 17.7865L18.96 18.7999C18.8267 18.9465 18.7333 19.2399 18.7467 19.4399L18.8267 20.7465C18.88 21.5465 18.3067 21.9599 17.56 21.6665L16.3467 21.1865C16.16 21.1199 15.84 21.1199 15.6533 21.1865L14.44 21.6665C13.6933 21.9599 13.12 21.5465 13.1733 20.7465L13.2533 19.4399C13.2667 19.2399 13.1733 18.9465 13.04 18.7999L12.2133 17.7865C11.6933 17.1732 11.92 16.4932 12.6933 16.2932L13.96 15.9732C14.16 15.9199 14.4 15.7332 14.5067 15.5599L15.2133 14.4665C15.6533 13.7865 16.3467 13.7865 16.7867 14.4665L17.4933 15.5599C17.6 15.7332 17.84 15.9199 18.04 15.9732L19.3067 16.2932C20.08 16.4932 20.3067 17.1732 19.7867 17.7865Z"
          fill="white"
        />
      </svg>
      <span>Best Patriotic Picks</span>
      <FlagIconsUS className="absolute -right-6 -top-3 size-8 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5" />
    </div>
  )
}
